module.exports = __webpack_public_path__ + "img/DsIcon-Info.efffc459.svg";